import { Link } from "react-router-dom";
import axios from "../../config/axios";

// importing styles
import styles from "./Footer.module.scss";

// importing data
import {
  businessOpportunities,
  FooterBusinessOpportunitiesLinks,
  FooterHelpCenterLinks,
  FooterKnowUsBetterLinks,
  mobileAboutUs,
  mobileHelpCenter,
  reaction_data,
} from "./data";

//importing components
import {
  Button,
  Col,
  Collapse,
  Divider,
  Input,
  message,
  Modal,
  Row,
  Select,
} from "antd";

// importing icons
import { DownOutlined } from "@ant-design/icons";
import { BsGlobe } from "react-icons/bs";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { IoCallSharp } from "react-icons/io5";
import { useState } from "react";
import ContactUs from "../ContactUs/ContactUs";
import footer1 from "./images/footer_1.png";
import footer3 from "./images/footer_3.png";
import loveImage from "./images/love.svg";
import { useWindowSize } from "react-use";
import GoogleReviews from "../GoogleReview/GoogleReview";

const Footer = () => {
  const { width } = useWindowSize();
  const pathname = window.location.pathname;

  return (
    <footer className={styles.footer}>
      <Row>
        {/* desktop footer */}
        <Col lg={24} md={24} sm={0} xs={0}>
          <div className="container">
            <Row gutter={[40, 25]}>
              <Col lg={9}>
                <span
                  style={{
                    color: "var(--color-primary)",
                    fontSize: "1.8rem",
                    fontWeight: 600,
                  }}
                >
                  Desi Fresh - Best value for authentic quality
                </span>
                <p style={{ color: "var(--color-grey)" }}>
                  Desi Fresh is a one-stop Asian online super market for
                  Indians, Bangladeshis, Pakistanis, and Srilankans residing in
                  Germany and nearby countries. We are rooted deep in the ‘Desi’
                  vibe of the cuisine and uphold quality, authenticity, and
                  transparency as the highest brand values. Our mission is to
                  provide with an extensive range of exotic high quality
                  products at an affordable price and contribute 2.5% profits to
                  underpriviledged kids.{" "}
                </p>

                <ul className={styles.contact}>
                  <li>
                    <IoCallSharp size={15} color={"var(--color-primary)"} />
                    <div>
                      <span>Hotline (Mo. -Sa. 8 -20 Hrs.)</span>
                      <span>+49 - 8161 - 5193561</span>
                    </div>
                  </li>
                  <li>
                    <FaMapMarkerAlt size={15} color={"var(--color-primary)"} />
                    <div>
                      <span>Königsteinstraße 1/3</span>
                      <span>80807 München Germany</span>
                      <span style={{ marginTop: 8 }}>Sonnenstraße 7a</span>
                      <span>85764 Oberschleißheim Germany</span>
                    </div>
                  </li>
                  <li>
                    <FiMail size={15} color={"var(--color-primary)"} />
                    <div>
                      <span>support@dfresh.com</span>
                    </div>
                  </li>
                </ul>

                <span
                  style={{
                    color: "var(--color-primary)",
                    fontSize: "1.8rem",
                    fontWeight: 600,
                    marginTop: 10,
                  }}
                >
                  Follow us
                </span>
                <div className={styles.icon_box}>
                  <a
                    href="https://www.facebook.com/dfresh.de"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook size={18} color={"var(--color-grey)"} />
                  </a>
                  <a
                    href="https://www.instagram.com/dfresh_de"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram size={18} color={"var(--color-grey)"} />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCPZDCA-MzmVJKRQ4FvCclCw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube size={18} color={"var(--color-grey)"} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/desi-fresh"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn size={18} color={"var(--color-grey)"} />
                  </a>
                  <a
                    href="https://twitter.com/DesiFresh_de"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter size={18} color={"var(--color-grey)"} />
                  </a>
                  <a
                    href="https://api.whatsapp.com/send?phone=4917670009491&text=Hello!"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp size={18} color={"var(--color-grey)"} />
                  </a>
                </div>
              </Col>
              <Col lg={5}>
                <div className={styles.footer_links_title}>Know us better</div>
                <div className={styles.footer_links}>
                  {FooterKnowUsBetterLinks.map((link, index) => (
                    <Link to={link.link} key={index}>
                      {link.title}
                    </Link>
                  ))}
                </div>
              </Col>
              <Col lg={5}>
                <div className={styles.footer_links_title}>Help Center</div>
                <div className={styles.footer_links}>
                  {FooterHelpCenterLinks.map((link, index) => (
                    <Link to={link.link} key={index}>
                      {link.title}
                      {link.icon && (
                        <img
                          height={16}
                          style={{ marginTop: "-10px", marginLeft: 5 }}
                          src={link.icon}
                          alt="icon"
                        />
                      )}
                    </Link>
                  ))}
                </div>
              </Col>
              <Col lg={5}>
                <div className={styles.footer_links_title}>
                  Business Opportunities
                </div>
                <div className={styles.footer_links}>
                  {FooterBusinessOpportunitiesLinks.map((link, index) => (
                    <Link to={link.link} key={index}>
                      {link.title}
                    </Link>
                  ))}
                </div>

                <br />

                <Select
                  defaultValue="english"
                  style={{
                    width: "100%",
                  }}
                >
                  <Select.Option value="english">
                    <div className={styles.lang_select}>
                      <BsGlobe size={15} />
                      <span> Deutschland - English</span>
                    </div>
                  </Select.Option>
                  <Select.Option value="dutch">
                    <div className={styles.lang_select}>
                      <BsGlobe size={15} />
                      <span> Deutschland - Deutsch</span>
                    </div>
                  </Select.Option>
                </Select>
              </Col>
            </Row>
          </div>

          <Row style={{ marginTop: 20 }}>
            <Col lg={24}>
              <div className="container">
                <div className={styles.partners}>
                  <span>Delivery Partners</span>
                  <img src={footer1} width={"40%"} alt="footer_1" />
                </div>
              </div>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col lg={24}>
              <div className="container">
                <div className={styles.trust_and_safety}>
                  <span>Trust & Safety</span>
                  <GoogleReviews />
                </div>
              </div>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col lg={24}>
              <div className="container">
                <div className={styles.payment_methods}>
                  <span>Payment Methods</span>
                  <img src={footer3} width={"60%"} alt="footer_3" />
                </div>
              </div>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col lg={24}>
              <div className="container">
                <div className={styles.copyright}>
                  <em>© 2023 Desi Fresh. All Rights Reserved.</em>
                  <div className={styles.copyright_list}>
                    <span>
                      <Link to={"/terms-and-condition"}>ABG</Link>
                    </span>
                    <span>
                      <Link to={"/imprint"}>Impressum</Link>
                    </span>
                    <span>
                      <Link to={"/data-protection"}>Data Protection</Link>
                    </span>
                    <span>
                      <Link to={"/cookies"}>Cookies</Link>
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={24}>
              <div className={styles.made_with}>
                <span>Made with</span>
                <span>
                  {" "}
                  <img src={loveImage} height="25" alt="love_image" />{" "}
                </span>
                <span>for Desi Community</span>
              </div>
              <span
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  color: "var(--color-grey-light)",
                }}
              >
                v0.2.0
              </span>
            </Col>
          </Row>
        </Col>

        {/* mobile footer */}
        <Col md={0} sm={24} xs={24} lg={0}>
          <Row gutter={[16, 16]}>
            <Col
              span={24}
              style={{
                display:
                  (pathname.includes("/category") ||
                    pathname.includes("/products")) &&
                    width < 576
                    ? "none"
                    : "",
              }}
            >
              <Collapse
                expandIcon={({ isActive }) => (
                  <DownOutlined size={20} rotate={isActive ? 180 : 0} />
                )}
                bordered={false}
                expandIconPosition="end"
                className="footer_collapse"
              >
                <Collapse.Panel
                  header={
                    <div className="fs-3 fw-bold">
                      Desi Fresh - Authentic multicultural groceries
                    </div>
                  }
                >
                  <div>
                    <p style={{ color: "var(--color-dark)" }}>
                      Desi Fresh is a one-stop Asian online super market for
                      Indians, Bangladeshis, Pakistanis, and Srilankans residing
                      in Germany and nearby countries. We are rooted deep in the
                      ‘Desi’ vibe of the cuisine and uphold quality,
                      authenticity, and transparency as the highest brand
                      values. Our mission is to provide with an extensive range
                      of exotic high quality products at an affordable price and
                      contribute 2.5% profits to underpriviledged kids.{" "}
                    </p>

                    <ul className={styles.contact}>
                      <li>
                        <IoCallSharp size={20} color={"var(--color-dark)"} />
                        <div>
                          <span>Hotline (Mo. -Sa. 8 -20 Hrs.)</span>
                          <span>+49 - 8161 - 5193561</span>
                        </div>
                      </li>
                      <li>
                        <FaMapMarkerAlt size={20} color={"var(--color-dark)"} />
                        <div>
                          <span>Königsteinstraße 1/3</span>
                          <span>80807 München Germany</span>
                          <span style={{ marginTop: 8 }}>Sonnenstraße 7a</span>
                          <span>85764 Oberschleißheim Germany</span>
                        </div>
                      </li>
                      <li>
                        <FiMail size={20} color={"var(--color-dark)"} />
                        <div>
                          <span>support@dfresh.com</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Collapse.Panel>

                <Collapse.Panel
                  header={<div className="fs-3 fw-bold">Help & Contact</div>}
                  style={{ fontSize: "3rem" }}
                >
                  <ContactUs />
                </Collapse.Panel>

                <Collapse.Panel
                  header={<div className="fs-3 fw-bold">Know Us Better</div>}
                >
                  <div className={styles.footer_links}>
                    {mobileAboutUs.map((link, index) => (
                      <Link to={link.link} key={index}>
                        {link.title}
                      </Link>
                    ))}
                  </div>
                </Collapse.Panel>
                <Collapse.Panel
                  header={<div className="fs-3 fw-bold">Our Services</div>}
                >
                  <div className={styles.footer_links}>
                    {mobileHelpCenter.map((link, index) => (
                      <Link to={link.link} key={index}>
                        {link.title}
                      </Link>
                    ))}
                  </div>
                </Collapse.Panel>
                <Collapse.Panel
                  header={
                    <div className="fs-3 fw-bold">Business Oppertunities</div>
                  }
                >
                  <div className={styles.footer_links}>
                    {businessOpportunities.map((link, index) => (
                      <Link to={link.link} key={index}>
                        {link.title}
                      </Link>
                    ))}
                  </div>
                </Collapse.Panel>
              </Collapse>
            </Col>

            <Col span={24}>
              <div className={styles.copyright}>
                <em className="pt-2">
                  © 2023 Desi Fresh. All Rights Reserved.
                </em>
                <div className={styles.copyright_list}>
                  <span>
                    <Link to={"/terms-and-condition"}>ABG</Link>
                  </span>
                  <span>
                    <Link to={"/imprint"}>Impressum</Link>
                  </span>
                  <span>
                    <Link to={"/data-protection"}>Data Protection</Link>
                  </span>
                  <span>Cookies</span>
                </div>
              </div>
            </Col>
            <Col span={24}>
              <div className={styles.made_with}>
                <span>Made with</span>
                <span>
                  {" "}
                  <img src={loveImage} height="25" alt="love_image" />{" "}
                </span>
                <span>for Desi Community</span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;

export const Reaction = () => {
  const [showReactionModal, setShowReactionModal] = useState(false);
  const [activeRating, setActiveRating] = useState(1);

  return (
    <div>
      {reaction_data.map((data, index) => (
        <img
          onClick={() => {
            setShowReactionModal(true);
            setActiveRating(data.rating);
          }}
          src={data.icon}
          alt={data.id}
          key={index}
        />
      ))}

      {showReactionModal && (
        <ReactionModal
          showReactionModal={showReactionModal}
          setShowReactionModal={setShowReactionModal}
          activeRating={activeRating}
        />
      )}
    </div>
  );
};

const ReactionModal = ({
  showReactionModal,
  setShowReactionModal,
  activeRating,
}) => {
  // find the active rating object from the reaction_data array
  const activeRatingObj = reaction_data.find(
    (data) => data.rating === activeRating
  );

  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const submitFeedback = async () => {
    const payload = {
      rating: activeRating,
      comment,
    };
    try {
      setLoading(true);
      await axios.post("/communications/site-experience", payload);
      message.success("Your feedback was recorded successfully!");
      setShowReactionModal(false);
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={showReactionModal}
      onClose={() => setShowReactionModal(false)}
      onCancel={() => setShowReactionModal(false)}
      centered
      footer={null}
      closeIcon={
        <img
          src="https://desi-fresh.b-cdn.net/components_static/Cross.svg"
          alt="close"
        />
      }
    >
      <div className={styles.reaction_modal_content}>
        <img src={activeRatingObj.icon} alt="icon" width={60} height={60} />

        <p>{activeRatingObj.text}</p>

        <Input.TextArea
          style={{ width: "100%" }}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Please write your feedback .... (optional)"
          autoSize={{ minRows: 3 }}
        />

        <Button
          type="primary"
          size="large"
          onClick={submitFeedback}
          loading={loading}
        >
          Send Feedback
        </Button>
      </div>
    </Modal>
  );
};
